import { render, staticRenderFns } from "./Piece.vue?vue&type=template&id=a6136234&scoped=true&"
import script from "./Piece.vue?vue&type=script&lang=js&"
export * from "./Piece.vue?vue&type=script&lang=js&"
import style0 from "./Piece.vue?vue&type=style&index=0&id=a6136234&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6136234",
  null
  
)

export default component.exports